/** Admin: one owner import's progress (OwnerScopeProvider twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import CustomerImportDetailScreen from '../../../../../../src/screens/CustomerImportDetailScreen';
export default function AdminOwnerCustomerImportDetail() {
  const { id, importId } = useLocalSearchParams<{ id: string; importId: string }>();
  return <OwnerScopeProvider ownerId={id ?? null}><CustomerImportDetailScreen importId={importId ?? ''} /></OwnerScopeProvider>;
}
